import { useTranslation } from "gatsby-plugin-react-i18next";

import { Box, Flex, Heading, Image } from "@theme/components";

import { getBlogSvgUrl } from "@theme/utils/images";

import type { FooterDataProps } from "@theme/types";

interface FooterPaymentMethodsProps {
  footerData: FooterDataProps;
}

export const FooterPaymentMethods = ({ footerData }: FooterPaymentMethodsProps) => {
  const { t } = useTranslation("common-phrases");

  return (
    <Box>
      <Heading variant="footerSectionHeading">
        {t("footerAcceptedPaymentMethods", { defaultValue: "Accepted payment methods" })}
      </Heading>

      <Flex
        as="ul"
        sx={{
          alignItems: "center",
          justifyContent: ["center", null, "flex-start"],
          width: ["full", null, null, "content02"],
          maxWidth: ["full", null, null, "content02"],
          flexWrap: "wrap",
          listStyle: "none",
          px: 0,
          mt: "s200",
          gap: "s200",
        }}
      >
        {footerData.availablePaymentMethods.map((paymentMethod, index) => (
          <Box as="li" key={`payment-method-svg-${index}`}>
            <Image
              src={getBlogSvgUrl(paymentMethod, footerData.isBlog)}
              alt=""
              sx={{ width: "full", height: "iconSizeBase" }}
              role="img"
            />
          </Box>
        ))}
      </Flex>
    </Box>
  );
};
